import axiosInstance from 'api/axiosInstance';
import { CANtrackCaseRaw } from './getCases';

async function getCase(id: number): Promise<CANtrackCaseRaw> {
	const data = await axiosInstance.get(`/api/cantrackv3/ReadCase?id=${id}`);
	if (!data || !data.data) throw new Error('Failed to fetch case');
	return data.data;
}

export default getCase;
